export default "/images/proplayers.png";